/**
 * Procedure Categories and Procedures for DM in Pediatric Hepatology students
 * Extracted with strict evidence from official NMC PDF (Page 4-5, 8-9: "The student should be able to perform independently")
 */
export const PEDIATRIC_HEPATOLOGY_PROCEDURES = {
  "Pediatric Diagnostic & Therapeutic Endoscopy Procedures": [
    "Pediatric Upper GI Endoscopy & Endoscopic Biopsies",
    "Pediatric Procto-Sigmoidoscopy & Colonoscopy",
    "Pediatric Endoscopic Variceal Band Ligation & Endoscopic Sclerotherapy",
    "Endoscopic Haemostatic Procedures (Argon Plasma Coagulation, Variceal Glue Injection)",
    "Endoscopic Stricture Dilatation & Endoscopic Stent Placement",
  ],
  "Pediatric Hepatobiliary, Biopsy & Vascular Intervention Procedures": [
    "Percutaneous Liver Biopsy in Pediatric Patients",
    "Transjugular Liver Biopsy (TJLB) & Transjugular Venous Catheterization (Under Supervision)",
    "Diagnostic & Therapeutic Abdominal Paracentesis in Children",
    "Bedside Pediatric Hepatobiliary Ultrasonography & Doppler Studies",
    "Pre- & Post-Operative Management of Pediatric Liver Transplantation",
  ],
};

export const PEDIATRIC_HEPATOLOGY_CATEGORIES = Object.keys(PEDIATRIC_HEPATOLOGY_PROCEDURES);

export const isDMInPediatricHepatologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("pediatric hepatology") ||
    d.includes("paediatric hepatology")
  );
};
